import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-www-main-description',
	templateUrl: './www-main-description.component.html',
	styleUrls: ['./www-main-description.component.scss'],
})
export class WwwMainDescriptionComponent extends ShowComponent {
	protected apiType = 'bag';
	protected parentComponent = 'www/descriptionMain';
	protected apiUrl = '/offer/description/';
	protected apiUrlAdd = '/offer/description/';

	private holdDescriptionHeader;
	private selectedHeader;

	protected getApiUrl(): string {
		return '/offer/description/' + this.data.id + '/';
	}

	data: any = {
		description: '',
		id: null,
		use: '',
		descriptionHeader: {
			comment: '',
			header: '',
			id: null,
			multimedia: null,
			name: '',
		},
	};

	protected descriptionHeaders;

	protected use = [
		{ id: 1, name: 'Autokar', code: 'C' },
		{ id: 2, name: 'Lot', code: 'F' },
		{ id: 3, name: 'Wszystkie', code: 'A' },
	];

	protected loadBefore() {
		this.bag.get('/description_header/', (result, error) => {
			this.descriptionHeaders = result.results;
			this.loadData();
		});
	}

	protected convertData(data: any) {
		this.selectedHeader = data.descriptionHeader;
		return data;
	}

	selectHeader(header) {
		this.selectedHeader = header;
	}

	protected checkForms() {
		if (this.data.use === '' || this.selectedHeader === undefined) {
			this.infobox.error('Uzupełnij poprawnie wszystkie pola!');
			return;
		}
		this.submit();
	}

	protected submitConvert(data: any) {
		this.holdDescriptionHeader = this.selectedHeader;
		data.descriptionHeader = this.selectedHeader.id;

		return data;
	}

	protected submitAfter(): void {
		this.data.descriptionHeader = this.holdDescriptionHeader;
	}
}
